export function common() {
  const header = document.getElementById("js-header");

  // const headerScroll = () => {
  //   window.addEventListener("scroll", () => {
  //     if (window.scrollY > 1 && window.innerWidth > 768) {
  //       header.classList.add("is-scroll");
  //     } else {
  //       header.classList.remove("is-scroll");
  //     }
  //   });
  // };

  // headerScroll();
  // ラジオボタン＆チェックボックスでテキスト改行（管理画面で入力した<br>を文字列ではなく改行として出力）
  jQuery(function () {
    jQuery('.wpcf7-list-item-label').each(function () {
      var text = jQuery(this).html();
      jQuery(this).html(text.replace('&lt;br&gt;', '<br>'));
    });
  });
}
